<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'بيانات المعلمين'" :to="{name: 'teachers'}">بيانات المعلمين</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'teachers.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات معلم</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="true"> <i class="fa-regular fa-user text-primary"></i> البيانات الشخصية</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"><i class="fa-regular fa-address-card text-primary"></i> معلومات التواصل</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="ident-tab" data-toggle="tab" href="#ident" role="tab" aria-controls="ident" aria-selected="false"><i class="fa-regular fa-address-book text-primary"></i> معلومات الهوية</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="work-tab" data-toggle="tab" href="#work" role="tab" aria-controls="work" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> معلومات العمل</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="exp-tab" data-toggle="tab" href="#exp" role="tab" aria-controls="exp" aria-selected="false"><i class="fa-regular fa-square-check text-primary"></i> المؤهل العلمى</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="auth-tab" data-toggle="tab" href="#auth" role="tab" aria-controls="auth" aria-selected="false"><i class="fa-regular fa-chart-bar text-primary"></i> لوحة التحكم</a>
                                </li>
                              </ul>
                              <form @submit.prevent="store()">
                                <div class="tab-content" id="myTabContent">
                                  <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                                    <div class="row mt-4">
                                      <div class="col-md-6">
                                              <label for="exampleFormControlInput12">الاسم <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                            <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                                  {{ getErrors['name'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                      <div class="col-md-3">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخ الميلاد</label>
                                            <date-picker v-model="data.form.birth_date"  :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['birth_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['birth_date']">
                                                  {{ getErrors['birth_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    <div class="col-md-3">

                                        <label for="exampleFormControlInput12">مكان الميلاد</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.birth_place" placeholder="مكان الميلاد">
                                            <div class="invalid-feedback" :style="getErrors['birth_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['birth_place']">
                                                  {{ getErrors['birth_place'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                   <div class="col-md-6">

                                        <label for="exampleFormControlInput12">الجنسية</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.nationality" placeholder="الجنسية">
                                            <div class="invalid-feedback" :style="getErrors['nationality'] ? 'display: block' : 'display: none;'"  v-if="getErrors['nationality']">
                                                  {{ getErrors['nationality'][0] }}
                                            </div>
                                        </div>
                                      </div>




                                      <div class="col-md-6">

                                       <label for="exampleFormControlInput12">الحالة الاجتماعية</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.marital_status" placeholder="الحالة الاجتماعية">
                                            <div class="invalid-feedback" :style="getErrors['marital_status'] ? 'display: block' : 'display: none;'"  v-if="getErrors['marital_status']">
                                                  {{ getErrors['marital_status'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups($event);" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف</label>
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessonsByStageOrGroup($event, 'group')" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع المعلم <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.isSupervisor" value="1"> <label for="">مشرف تربوى</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.isSupervisor" value="0" > <label for="">معلم</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['isSupervisor'] ? 'display: block' : 'display: none;'"  v-if="getErrors['isSupervisor']">
                                                  {{ getErrors['isSupervisor'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">{{data.form.isSupervisor == 0 ? 'الحلقة' : 'الحلقات'}} <span class="text-danger">*</span></label>
                                            <treeselect :options="lessons" v-model="data.form.lessons" :multiple="data.form.isSupervisor == 0 ? false : true"/>
                                            <div class="invalid-feedback" :style="getErrors['lessons'] ? 'display: block' : 'display: none;'"   v-if="getErrors['lessons']">
                                                  {{ getErrors['lessons'][0] }}
                                            </div>
                                        </div>
                                      </div>



                                      <div class="col-md-7">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع العمل</label>
                                            <div class="row">
                                              <div class="col-md-4">
                                                <input type="radio" v-model="data.form.work_type" value="إدارى"> <label for="">إدارى</label>
                                              </div>
                                              <div class="col-md-4">
                                                <input type="radio" v-model="data.form.work_type" value="معلم" > <label for="">معلم</label>
                                              </div>
                                              <div class="col-md-4">
                                                <input type="radio" v-model="data.form.work_type" value="أخرى"> <label for="">أخرى</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['work_type'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_type']">
                                                  {{ getErrors['work_type'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-5" v-if="data.form.work_type == 'أخرى'">
                                       <label for="exampleFormControlInput12"> نوع العمل</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.work_type_txt" placeholder="اكتب نوع العمل">
                                            <div class="invalid-feedback" :style="getErrors['work_type_txt'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_type_txt']">
                                                  {{ getErrors['work_type_txt'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                    </div>
                                  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                     <div class="row mt-4">
                                      <div class="col-md-6">
                                      <label for="exampleFormControlInput12">عنوان المنزل</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.address" placeholder="اكتب العنوان">
                                            <div class="invalid-feedback" :style="getErrors['address'] ? 'display: block' : 'display: none;'"  v-if="getErrors['address']">
                                                  {{ getErrors['address'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                      <label for="exampleFormControlInput12">الحى</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.neighborhood" placeholder="اكتب الحى">
                                            <div class="invalid-feedback" :style="getErrors['neighborhood'] ? 'display: block' : 'display: none;'"  v-if="getErrors['neighborhood']">
                                                  {{ getErrors['neighborhood'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                      <label for="exampleFormControlInput12">رقم الجوال <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.mobile" placeholder="رقم الجوال">
                                            <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['mobile']">
                                                  {{ getErrors['mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                       <label for="exampleFormControlInput12">رقم واتس آب <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.whatsapp" placeholder="رقم واتس آب">
                                            <div class="invalid-feedback" :style="getErrors['whatsapp'] ? 'display: block' : 'display: none;'"  v-if="getErrors['whatsapp']">
                                                  {{ getErrors['whatsapp'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <label for="exampleFormControlInput12">هاتف المنزل</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.phone" placeholder="هاتف المنزل">
                                            <div class="invalid-feedback" :style="getErrors['phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['phone']">
                                                  {{ getErrors['phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <label for="exampleFormControlInput12"> البريد الإلكتروني <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                      </div>

                                            <input type="email" class="form-control" v-model="data.form.email" placeholder="البريد الإلكتروني">
                                            <div class="invalid-feedback" :style="getErrors['email'] ? 'display: block' : 'display: none;'"  v-if="getErrors['email']">
                                                  {{ getErrors['email'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                  <div class="tab-pane fade" id="ident" role="tabpanel" aria-labelledby="ident-tab">
                                    <div class="row mt-4">
                                      <div class="col-md-6">
                                        <label for="exampleFormControlInput12">رقم الهوية <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.id_number" placeholder="رقم الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_number'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_number']">
                                                  {{ getErrors['id_number'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                          <label for="exampleFormControlInput12">مصدرها</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.id_place" placeholder="مصدر الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_place']">
                                                  {{ getErrors['id_place'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div :class="'col-md-' + (data.form.id_type == 'أخرى' ? '6' : '12')">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع الهوية <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="بطاقة احوال"> <label for="">بطاقة احوال</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="إقامة" > <label for="">إقامة</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="أخرى"> <label for="">أخرى</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['id_type'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_type']">
                                                  {{ getErrors['id_type'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6" v-if="data.form.id_type == 'أخرى'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع الهوية</label>
                                            <input type="text" class="form-control" v-model="data.form.id_type_txt" placeholder="اكتب نوع الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_type_txt'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_type_txt']">
                                                  {{ getErrors['id_type_txt'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخها</label>
                                            <date-picker v-model="data.form.id_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['id_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_date']">
                                                  {{ getErrors['id_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخ الانتهاء</label>
                                            <date-picker v-model="data.form.id_expire_date"  :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['id_expire_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_expire_date']">
                                                  {{ getErrors['id_expire_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="work" role="tabpanel" aria-labelledby="work-tab">
                                    <div class="row mt-4">
                                      <div class="col-md-6">
  <label for="exampleFormControlInput12">العمل الرسمى</label>
                                    <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.work" placeholder="العمل الرسمى">
                                            <div class="invalid-feedback" :style="getErrors['work'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work']">
                                                  {{ getErrors['work'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                <label for="exampleFormControlInput12">العنوان</label>
                                    <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.work_address" placeholder="اكتب عنوان العمل">
                                            <div class="invalid-feedback" :style="getErrors['work_address'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_address']">
                                                  {{ getErrors['work_address'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
<label for="exampleFormControlInput12">مكان العمل</label>
         <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.work_place" placeholder="مكان العمل">
                                            <div class="invalid-feedback" :style="getErrors['work_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_place']">
                                                  {{ getErrors['work_place'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                        <label for="exampleFormControlInput12">الهاتف</label>
         <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>



                                            <input type="text" class="form-control" v-model="data.form.work_phone" placeholder="الهاتف">
                                            <div class="invalid-feedback" :style="getErrors['work_phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_phone']">
                                                  {{ getErrors['work_phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="exp" role="tabpanel" aria-labelledby="exp-tab">
                                    <div class="row mt-4">

                                      <div class="col-md-12 mb-4">
                                        <h4 for="exampleFormControlInput12">اجازة القراءنية | <a href="#" @click.prevent="data.form.quaran.push('')">اضف اجازة</a></h4>
                                        <table v-if="data.form.quaran.length" style="width: 100%">
                                          <thead>
                                            <tr>
                                              <th>#</th>
                                              <th>حذف</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(v,k) in data.form.quaran" :key="k">
                                              <td>
                                                <input type="text" class="form-control" v-model="data.form.quaran[k]" placeholder="الاجازة">
                                              </td>
                                              <td>
                                                <button class="btn btn-danger" @click="data.form.quaran.splice(data.form.quaran.indexOf(v), 1);">X</button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div class="invalid-feedback" :style="getErrors['quaran'] ? 'display: block' : 'display: none;'"  v-if="getErrors['quaran']">
                                              {{ getErrors['quaran'][0] }}
                                        </div>
                                      </div>
                                      <hr>
                                      <div class="col-md-12 mb-4">
                                        <h4 for="exampleFormControlInput12">الدورات الحاصل عليا | <a href="#" @click.prevent="data.form.courses.push('')">اضف دوورة</a></h4>
                                        <table v-if="data.form.courses.length" style="width: 100%">
                                          <thead>
                                            <tr>
                                              <th>#</th>
                                              <th>حذف</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(v,k) in data.form.courses" :key="k">
                                              <td>
                                                <input type="text" class="form-control" v-model="data.form.courses[k]" placeholder="الدورات الحاصل عليها">
                                              </td>
                                              <td>
                                                <button class="btn btn-danger" @click="data.form.courses.splice(data.form.courses.indexOf(v), 1);">X</button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div class="invalid-feedback" :style="getErrors['courses'] ? 'display: block' : 'display: none;'"  v-if="getErrors['courses']">
                                              {{ getErrors['courses'][0] }}
                                        </div>
                                      </div>
                                      <hr>
                                      <div class="col-md-12">
                                        <h4 for="exampleFormControlInput12"> الخبرات | <a href="#" @click.prevent="data.form.experience.push('')">اضف خبرة</a></h4>
                                        <table v-if="data.form.experience.length" style="width: 100%">
                                          <thead>
                                            <tr>
                                              <th>#</th>
                                              <th>حذف</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(v,k) in data.form.experience" :key="k">
                                              <td>
                                                <input type="text" class="form-control" v-model="data.form.experience[k]" placeholder="الخبرات">
                                              </td>
                                              <td>
                                                <button class="btn btn-danger" @click="data.form.experience.splice(data.form.experience.indexOf(v), 1);">X</button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div class="invalid-feedback" :style="getErrors['experience'] ? 'display: block' : 'display: none;'"  v-if="getErrors['experience']">
                                              {{ getErrors['experience'][0] }}
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="auth" role="tabpanel" aria-labelledby="auth-tab">
                                     <div class="row mt-4">
                                      <div class="col-md-4">
<label for="exampleFormControlInput12"> البريد الإلكتروني </label>
<div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                      </div>



                                            <input type="email" class="form-control" v-model="data.form.auth_email" placeholder="البريد الإلكتروني">
                                            <div class="invalid-feedback" :style="getErrors['auth_email'] ? 'display: block' : 'display: none;'"  v-if="getErrors['auth_email']">
                                                  {{ getErrors['auth_email'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <label for="exampleFormControlInput12">اسم المستخدم <span class="text-danger">*</span></label>
                                        <div class="input-group mb-4">

                                        <div class="input-group-prepend">
                                          <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                        </div>



                                            <input type="text" class="form-control" v-model="data.form.auth_username" placeholder="اسم المستخدم">
                                            <div class="invalid-feedback" :style="getErrors['auth_username'] ? 'display: block' : 'display: none;'"  v-if="getErrors['auth_username']">
                                                  {{ getErrors['auth_username'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-4">
 <label for="exampleFormControlInput12">كلمة المرور <span class="text-danger">*</span></label>         <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>



                                            <input type="password" class="form-control" v-model="data.form.auth_password" placeholder="كلمة المرور">
                                            <div class="invalid-feedback" :style="getErrors['auth_password'] ? 'display: block' : 'display: none;'"  v-if="getErrors['auth_password']">
                                                  {{ getErrors['auth_password'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'teachers'}">
                                      <span>رجوع</span>
                                    </router-link>

                                    </form>

                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueDatetimeJs from 'vue-datetime-js'
export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      date: '',
      lessons: [],
      groups: [],
      stages: [],
      data: {
        checker: false,
        form:{
            stage_id: '',
            group_id: '',
            lessons: [],
            isSupervisor: 0,
            name: '',
            birth_date: '',
            birth_place: '',
            nationality: '',
            marital_status: '',
            work_type: 'إدارى',
            work_type_txt: '',
            address: '',
            neighborhood: '',
            whatsapp: '',
            phone: '',
            email: '',
            id_number: '',
            id_place: '',
            id_type: '',
            id_type_txt: '',
            id_date: '',
            id_expire_date: '',
            work: '',
            work_address: '',
            work_place: '',
            work_phone: '',
            quaran: [],
            courses: [],
            experience: [],

            auth_email: '',
            auth_username: '',
            auth_passord: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
    this.getRequirements();
  },
  methods: {
      resetForm(){
        this.data.form ={
            stage_id: '',
            group_id: '',
            lessons: [],
            isSupervisor: 0,
            name: '',
            birth_date: '',
            birth_place: '',
            nationality: '',
            marital_status: '',
            work_type: 'إدارى',
            work_type_txt: '',
            address: '',
            neighborhood: '',
            whatsapp: '',
            phone: '',
            email: '',
            id_number: '',
            id_place: '',
            id_type: '',
            id_type_txt: '',
            id_date: '',
            id_expire_date: '',
            work: '',
            work_address: '',
            work_place: '',
            work_phone: '',
            quaran: [],
            courses: [],
            experience: [],

            auth_email: '',
            auth_passord: '',
        };
      },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/teachers', this.data.form).then((response)=>{
            if(response.data.code === 200){
          localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/teachers');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
         this.getLessons();
         this.getStages();
      },
      getLessons(){
        this.$baseApi.get('/teachers/create').then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getLessonsByStageOrGroup(val, type){
        this.$baseApi.get('/teachers/create?option=lesson&type='+type+'&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getLessonsByStageOrGroupOp(val, type){
        this.lessons = [];
        this.$baseApi.get('/teachers/create?option=lesson&type='+type+'&i='+val).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getStages(){
      this.data.form.group_id = '';
        this.$baseApi.get('/teachers/create?option=stage&here=1').then((response)=>{
            if(response.data.code == 200){
               this.stages = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getGroups(val){
        this.groups = [];
        this.data.form.group_id = '';
        this.$baseApi.get('/teachers/create?ss=1&option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.options;
               this.getLessonsByStageOrGroupOp(val.id, 'stage');
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.data.form.location_id = node.id;
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  }
};
</script>
<style>
</style>
